document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".collection-slideshow");

  sliders.forEach((slider) => {
    initSlider(slider);
  });
});

function initSlider(slider) {
  const track = slider.querySelector(".collection-slideshow__track");
  const slides = slider.querySelectorAll(".collection-slide");
  const prevBtn = slider.querySelector(".collection-prev");
  const nextBtn = slider.querySelector(".collection-next");
  const dots = slider.querySelectorAll(".collection-dot");

  if (!track || slides.length === 0) return;

  let index = 0;
  let interval;
  const speed = 5000;

function update() {
  const slideWidth = slider.offsetWidth;
  track.style.transform = `translateX(-${index * slideWidth}px)`;

  dots.forEach((dot, i) => {
    dot.classList.toggle("active", i === index);
  });
}

  function next() {
    index = (index + 1) % slides.length;
    update();
  }

  function prev() {
    index = (index - 1 + slides.length) % slides.length;
    update();
  }

  // ✅ IMPORTANT: ensure buttons exist before binding
  if (nextBtn) {
    nextBtn.addEventListener("click", (e) => {
      e.preventDefault();
      next();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", (e) => {
      e.preventDefault();
      prev();
    });
  }

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      index = parseInt(dot.dataset.index, 10);
      update();
    });
  });

  function start() {
    stop();
    interval = setInterval(next, speed);
  }

  function stop() {
    if (interval) clearInterval(interval);
  }

  slider.addEventListener("mouseenter", stop);
  slider.addEventListener("mouseleave", start);

  // swipe
  let startX = 0;

  slider.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  slider.addEventListener("touchend", (e) => {
    const endX = e.changedTouches[0].clientX;

    if (startX - endX > 50) next();
    if (endX - startX > 50) prev();
  });

  update();
  start();
}